import { toast } from 'sonner'

import { parseError } from '@/lib/errors'

/** True once saved; otherwise says why, for the forms that don't show the API's errors on their fields. */
export function saved(save: Promise<void>): Promise<boolean> {
  return save.then(
    () => true,
    (error: unknown) => {
      toast.error(parseError(error))
      return false
    }
  )
}
